<div id="dfwm-wrapper">
  <div id="dfwm-inner">
    <dfwm-header></dfwm-header>
    <div class="dfwm-body">
      <router-outlet></router-outlet>
    </div>
    <dfwm-footer></dfwm-footer>
  </div>
</div>
